import React from "react";
import { Sparkles } from "lucide-react";

export default function OfferBanner() {
  return (
    <div className="bg-brand-navy text-white text-[13px]" data-testid="offer-banner">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-2.5 flex items-center justify-center gap-3 flex-wrap">
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-brand-gold text-brand-navy text-[11px] font-bold uppercase tracking-wider">
          <Sparkles className="w-3 h-3" /> Offerta attiva
        </span>
        <span className="font-semibold">Fino a <span className="text-brand-gold">-50%</span> sulla retta</span>
        <span className="text-white/40">•</span>
        <span>Rate da <span className="font-bold">125€/mese</span></span>
        <span className="text-white/40 hidden sm:inline">•</span>
        <span className="hidden sm:inline">Convenzioni Pegaso · Mercatorum · San Raffaele</span>
      </div>
    </div>
  );
}
